"use client"

import styled from "@emotion/styled"
import { Box, Link, Typography } from "@mui/material"
import Image from "next/image"
import React from "react"
import { getNonUmbracoUrl, getUmbracoMediaUrl } from "utils"
import { ButtonWithArrowTall } from "../common/bit/ButtonWithArrow"
import CommonTitle from "../common/bit/CommonTitle"
import { useIsDesktop } from "../common/bit/MediaQueries"
import SwiperWithButtons from "../SwiperWithButtons/SwiperWithButtons"
import { colors, mediaQueries, sizes } from "../theme/theme"

interface ButtonsListProps {
  data: {
    title: string
    itemsList: Record<string, any>
    link?: {
      url: string
      name: string
    }
  }
}

const StyledCommonTitle = styled(CommonTitle)`
  ${mediaQueries.desktopM} {
    margin-bottom: 0;
  }
`

const StyledSwiperWithButtons = styled(SwiperWithButtons)`
  display: flex;
  flex-flow: row wrap;
  align-items: center;
  gap: ${sizes.baseDouble};
  .MuiButton-root {
    margin-top: ${sizes.baseSix};
  }
`
const StyledButtonWithArrow = styled(ButtonWithArrowTall)`
  justify-content: space-between;
  padding: ${sizes.baseDouble} ${sizes.baseTriple};
  width: 442px;
  height: 100%;
  flex-grow: 1;
  ${mediaQueries.mobile} {
    width: 100%;
  }
  .title {
    font-size: 24px;
    text-align: start;
  }
  .content {
    height: 100%;
    align-items: flex-start;
    justify-content: space-between;
  }
  svg {
    margin-top: auto;
  }
`
const LogoWrapper = styled(Box)`
  display: flex;
  flex-flow: row wrap;
  justify-content: space-between;
  align-items: center;
  margin-top: ${sizes.baseDouble};
  > * {
    margin-inline-end: ${sizes.baseSingle};
    :last-child {
      border-inline-start: 1px solid ${colors.borderGray};
      padding-inline-start: ${sizes.baseDouble};
      color: ${colors.black};
    }
  }
  img {
    height: ${sizes.baseQuadric};
  }
`

const LinkIconCardSwiper: React.FC<ButtonsListProps> = ({ data }) => {
  const { title, itemsList, link } = data
  const isDesktop = useIsDesktop()
  return (
    <>
      <StyledCommonTitle>{title}</StyledCommonTitle>
      <StyledSwiperWithButtons
        sidesButtonsDesktop
        iconName="arrow_red_white"
        iconNameMobile="arrow_lightPink_black_line"
        swiperProps={{
          slidesPerView: isDesktop ? 3 : 1,
          slidesPerGroup: 1,
          spaceBetween: isDesktop ? 20 : 10,
          centeredSlides: false,
          freeMode: true,
        }}
      >
        {itemsList &&
          itemsList.map(
            (
              item: { title: any; link: any; logo: any; year: any },
              index: any,
            ) => {
              const { title, link, logo, year } = item
              return (
                <StyledButtonWithArrow
                  key={`accordion-item-${title}-${index}`}
                  arrowName="arrow_lightRed_black"
                  variant="elevated"
                  colorPallette="red"
                  href={getNonUmbracoUrl(link?.url)}
                >
                  {title && (
                    <Typography variant="h3" className="title">
                      {title}
                    </Typography>
                  )}
                  {(logo || year) && (
                    <LogoWrapper>
                      {logo && (
                        <Image
                          height={32}
                          width={42}
                          src={getUmbracoMediaUrl(logo?.url)}
                          alt={logo?.altText || title}
                          style={{ objectFit: "contain" }}
                        />
                      )}
                      {year && <Typography variant="body1">{year}</Typography>}
                    </LogoWrapper>
                  )}
                </StyledButtonWithArrow>
              )
            },
          )}
      </StyledSwiperWithButtons>
      {link && <Link href={getNonUmbracoUrl(link?.url)}>{link?.name}</Link>}
    </>
  )
}

export default LinkIconCardSwiper
